module.exports = __webpack_public_path__ + "img/verified.416ee1ac.png";